import Card from '../Card/Card';
import ExamCompleted from '../../assets/images/exam_complete.png';
import Balloons from '../../assets/images/balloons.png';
import { useState } from 'react';
import axios from 'axios';
import { getSessionToken } from 'utils/session';

const AgreementProcess = () => {
  const [resendStatus, setResendStatus] = useState('');
  const handleResendRequest = async () => {
    try {
      setResendStatus('Sending...');

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/training/pos_agreement_email/`,
        {}, // Empty request body
        {
          headers: {
            Authorization: `Bearer ${getSessionToken()}`,
          },
        }
      );

      setResendStatus('Request sent successfully!');
    } catch (error) {
      setResendStatus('Failed to send request. Try again.');
    }
  };

  return (
    <Card>
      <div className="flex flex-col md:flex-row items-center gap-9">
        {/* Left Side - Exam Completed Image */}
        <div className="w-full text-center">
          <img
            src={ExamCompleted}
            alt="Exam Completed"
            className="inline-block w-52 md:w-72 lg:w-80"
          />
        </div>

        {/* Right Side - Message & Balloons */}
        <div className="w-full text-center flex flex-col items-center gap-6">
          <img
            src={Balloons}
            alt="Success"
            className="inline-block w-32 md:w-40 lg:w-48"
          />

          <h6 className="text-lg md:text-xl font-semibold text-green-600">
            🎉 Exam Passed!
          </h6>

          <p className="text-sm md:text-base text-gray-700">
            You have successfully completed your exam.
          </p>

          <p className="text-sm md:text-base text-gray-600">
            Check if you received an agreement email.
          </p>

          <p className="text-sm md:text-base text-gray-600">
            If you didn’t get an email, click below to resend the request.
          </p>

          {/* Resend Request Button */}
          <button
            className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-all duration-300"
            onClick={handleResendRequest}
          >
            Resend Request
          </button>

          {/* Status Message */}
          {resendStatus && (
            <p className="mt-2 text-sm text-gray-700">{resendStatus}</p>
          )}
        </div>
      </div>
    </Card>
  );
};

export default AgreementProcess;
